<div class="action-bar box w-100 flex flex-column">

    <div class="flex flex-row justify-content-space-between w-100 top">
        <div class="flex align-items-center">
            <ng-content select="[left]"></ng-content>
        </div>
        <div class="flex">
            <ng-content select="[right]"></ng-content>
        </div>
    </div>
        
    <div class="bottom">
        <ng-content select="[bottom]"></ng-content>
    </div>

</div>
